export default "__VITE_ASSET__BbDwbgNo__"